
export const getUserData = () => {
  try {
    const storedData = localStorage.getItem('user_profile');
    const parsedData = storedData ? JSON.parse(storedData) : {};

    // Ensure it returns a safe object, not null
    if (parsedData && typeof parsedData === "object") {
      return parsedData;
    } else {
      return {};
    }
  } catch (error) {
    console.error('Error parsing user data from localStorage:', error);
    return {};
  }
};


export const logoutUser = (navigate) => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('user_profile');
  navigate('/auth/sign-in');
};

export function formatUSPhoneNumber(number) {
  if (typeof number !== "string") return number || "N/A";

  const digits = number.replace(/\D/g, '');
  const cleaned = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

  if (cleaned.length !== 10) return number;

  const areaCode = cleaned.slice(0, 3);
  const centralOffice = cleaned.slice(3, 6);
  const lineNumber = cleaned.slice(6);

  return `+1 (${areaCode}) ${centralOffice}-${lineNumber}`;
}

export const X_API_Key = "d83dabcea80d37864dfd2f5c99c075fe475cccb31998bda99f8978e3e5897ac7"


